import { apiService } from './api';
import { MenuItemTypeDTO, CreateMenuTypeDTO } from '../types';

const API = '/menu-types';

export const menuTypeService = {
  getAll: (pageNumber = 1, pageSize = 100) =>
    apiService.get<{ data: MenuItemTypeDTO[] }>(API, { pageNumber, pageSize }),

  getById: (id: number) =>
    apiService.get<MenuItemTypeDTO>(`${API}/${id}`),

  create: (data: CreateMenuTypeDTO) =>
    apiService.post<MenuItemTypeDTO>(API, data),

  update: (id: number, data: Partial<CreateMenuTypeDTO>) =>
    apiService.put<MenuItemTypeDTO>(`${API}/${id}`, data),

  delete: (id: number) =>
    apiService.delete<boolean>(`${API}/${id}`),
};
